import React, { useState } from "react";
import { useTheme } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Modal from "@material-ui/core/Modal";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import InfoIcon from "@material-ui/icons/Info";
import CancelIcon from "@material-ui/icons/Cancel";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { toast } from "react-toastify";

const InfoAsaas = () => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  const backendUrl = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
  const webhookUrl = `${backendUrl}/subscription/asaaswebhook`;

  const handleCopy = async (text, label) => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success(`${label} copiado!`);
    } catch {
      toast.error("Não foi possível copiar.");
    }
  };

  return (
    <div>
      <IconButton onClick={() => setOpen(true)} aria-label="Manual de integração Asaas">
        <InfoIcon style={{ color: "black" }} />
      </IconButton>
      <Modal open={open} onClose={() => setOpen(false)}>
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: theme.palette.background.paper,
            padding: "24px",
            borderRadius: "8px",
            outline: "none",
            maxWidth: "720px",
            width: "92%",
            maxHeight: "85vh",
            overflow: "auto",
            color: theme.palette.text.primary,
          }}
        >
          <IconButton
            style={{ position: "absolute", top: "8px", right: "8px" }}
            onClick={() => setOpen(false)}
          >
            <CancelIcon />
          </IconButton>

          <Typography variant="h5" gutterBottom>
            Manual — Integração Asaas (assinaturas)
          </Typography>

          <Typography variant="body2" color="textSecondary" paragraph>
            Siga os passos abaixo para cobrar licenças mensais com cliente vinculado por CPF/CNPJ.
          </Typography>

          <Typography variant="subtitle1" gutterBottom>
            <strong>1. Conta e ambiente</strong>
          </Typography>
          <Typography variant="body2" paragraph>
            Crie uma conta no{" "}
            <a href="https://www.asaas.com" target="_blank" rel="noopener noreferrer">
              Asaas
            </a>{" "}
            (produção) ou no{" "}
            <a href="https://sandbox.asaas.com" target="_blank" rel="noopener noreferrer">
              sandbox.asaas.com
            </a>{" "}
            para testes. Marque <strong>Usar sandbox Asaas</strong> nesta tela enquanto estiver testando.
          </Typography>

          <Typography variant="subtitle1" gutterBottom>
            <strong>2. Token de API</strong>
          </Typography>
          <Typography variant="body2" paragraph>
            No painel Asaas: <em>Integrações → API → Gerar / copiar token</em>. Cole o token no campo
            <strong> Token Asaas</strong> abaixo.
          </Typography>

          <Typography variant="subtitle1" gutterBottom>
            <strong>3. Meio de pagamento ativo</strong>
          </Typography>
          <Typography variant="body2" paragraph>
            Em <strong>Cobrança / Pagamentos</strong>, selecione <strong>Asaas (assinatura)</strong> como
            meio de pagamento ativo. Apenas um gateway pode ficar ativo por vez.
          </Typography>

          <Typography variant="subtitle1" gutterBottom>
            <strong>4. Webhook (obrigatório)</strong>
          </Typography>
          <Typography variant="body2" paragraph>
            No Asaas: <em>Integrações → Webhooks → Adicionar URL</em>. Cole a URL abaixo e marque os eventos
            <strong> PAYMENT_CREATED</strong> e <strong> PAYMENT_RECEIVED</strong>.
          </Typography>

          <Box
            display="flex"
            alignItems="center"
            flexWrap="wrap"
            mb={2}
            p={1.5}
            bgcolor={theme.palette.action.hover}
            borderRadius={4}
            style={{ gap: 8 }}
          >
            <Typography variant="body2" component="code" style={{ wordBreak: "break-all", flex: 1 }}>
              {webhookUrl}
            </Typography>
            <Button
              size="small"
              variant="outlined"
              startIcon={<FileCopyIcon />}
              onClick={() => handleCopy(webhookUrl, "URL do webhook")}
            >
              Copiar URL
            </Button>
          </Box>

          <Typography variant="subtitle1" gutterBottom>
            <strong>5. Cadastro das empresas clientes</strong>
          </Typography>
          <Typography variant="body2" paragraph>
            Cada empresa que for pagar licença precisa ter <strong>CPF ou CNPJ</strong> preenchido no cadastro.
            O sistema busca ou cria o cliente no Asaas automaticamente com esse documento.
          </Typography>

          <Typography variant="subtitle1" gutterBottom>
            <strong>6. Valor mínimo</strong>
          </Typography>
          <Typography variant="body2" paragraph>
            Cobranças Asaas só são geradas para planos com valor <strong>acima de R$ 10,00</strong> (mínimo
            efetivo: <strong>R$ 10,01</strong>). Planos abaixo disso não geram cobrança no Asaas.
          </Typography>

          <Typography variant="subtitle1" gutterBottom>
            <strong>7. Experiência do cliente no checkout</strong>
          </Typography>
          <Typography variant="body2" paragraph>
            O cliente pode pagar via PIX (se disponível), copiar a linha digitável ou abrir a fatura no Asaas
            para escolher <strong>boleto ou PIX</strong>. Quando o boleto existir, aparece o botão{" "}
            <strong>Baixar boleto (PDF)</strong>.
          </Typography>

          <Typography variant="subtitle1" gutterBottom>
            <strong>8. Confirmação automática</strong>
          </Typography>
          <Typography variant="body2">
            Após o pagamento, o webhook confirma a fatura, renova a licença (+30 dias) e reativa conexões
            conforme configurado no sistema.
          </Typography>
        </div>
      </Modal>
    </div>
  );
};

export default InfoAsaas;
